import React from 'react';
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import EmailCapture from '../components/EmailCapture'

const SubscribePage = () => {


  return (
    <Layout>
      <SEO title="Subscribe" />
      <h1 className="mb-8 leading-loose font-extrabold text-4xl text-center">
        Subscribe
      </h1>
      <EmailCapture />
    </Layout>
  );
};

export default SubscribePage;